import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";


const PageTitlesSM = ({icono, texto, subtexto, retorno}) => {
    const navigate = useNavigate();
    return (
        <>

      <div class="row">
        <div class="col-2 smallTitle">
        <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate(retorno)}}/>
        </div>
        <div class="col-2 smallTitlePri">
        <img src={icono}  width="30px"/>
        </div>
       <div class="col-6 smallTitleSecGeneric2">
            {texto}
            </div>
            </div>
            <div class="row">
                {subtexto?
                <div class="col smallSubtitle2">
                    {subtexto}
                </div>:
                <div class="col smallSubtitle2">
                &nbsp;
            </div>
                }
            </div>
        </>

    );
    }
export default PageTitlesSM;